import { Component, OnChanges, Input, HostListener, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'app/services/loader.service';
import { NgClass } from '@angular/common';

export type subMenuItemType = {
  key: string;
  title: string;
}

@Component({
    selector: 'SubMenu',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.scss'],
    imports: [NgClass]
})

export class SubMenuComponent implements OnChanges {
  private route = inject(ActivatedRoute);
  private loaderService = inject(LoaderService);

  @Input() items: subMenuItemType[] = [];
  public supportPageOffset = false;
  public submenu: null | HTMLElement = null;
  public keys: string[] = [];

  constructor() {
    this.supportPageOffset = window.pageYOffset !== undefined;
  }

  ngOnChanges(): void {
    this.keys = [];
    this.items.forEach(i => {this.keys.push(i.key)});

    this.route.params.subscribe( params => {
      if (this.keys.indexOf(params['tag']) !== -1) this.navigateTo(params['tag']);
    });
  }

  navigateTo(tag: string): void {
    this.loaderService.navigateTo.next(tag);
  }

  @HostListener("window:scroll", ['$event'])
  onWindowScroll(): void {
    if (!this.submenu) this.submenu = document.getElementById('subnav');
    if (!$(this.submenu!).is(':visible')) return;
    const menupos = this.submenu!.getBoundingClientRect().bottom;
    $('.nav-link').removeClass('nav-selected').blur();
    const a = $('.anchor');
    for (let i = a.length; i>0; i--) {
      if (this.keys.indexOf(a[i-1].id) == -1) continue;
      if (i == 1 || menupos >= a[i-1].getBoundingClientRect().top) {
        $('.nav-link-' + a[i-1].id).addClass('nav-selected');
        return;
      }
    }
  }
}
